module.exports = __webpack_public_path__ + "img/5-download-template.ee5b0709.png";